<template>
  <v-app>
    <v-main>
      <!-- SplashScreen -->
      <splashScreen v-if="showSplash" />

      <!-- RouterView -->
      <router-view v-else />
    </v-main>
  </v-app>
</template>

<script>
import splashScreen from "./components/splashScreen/splashScreen.vue";

export default {
  name: "App",
  components: {
    splashScreen,
  },
  data: () => ({
    showSplash: true,
  }),
  mounted() {
    setTimeout(() => {
      this.showSplash = false;
    }, 3000); // 3 segundos
  },
};
</script>

<style>
.splash-screen {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: #f3c53e;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  z-index: 9999;
}
</style>
